import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigation, useSubmit } from "react-router-dom";
import CommonInputs from "./CommonInputs";

const validationSchema = Yup.object().shape({
  selectedReason: Yup.string().required("Medical service is required field"),
  assistanceRequired: Yup.string().required("Assistance type is a required field"),
  name: Yup.string()
    .required("Full name a required field")
    .matches(/^[a-zA-Z. ]+$/, "Invalid characters. Only letters, spaces, and (.) are allowed."),
  email: Yup.string()
    .email("Please enter a valid email address.")
    .required("Email Id a required field")
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|gov|org)$/, "Please enter a valid email address."),
  contact: Yup.string()
    .matches(/^(?:\+91\s?)?(\d{5}[-\s]?\d{5})$/, "Contact number should be a 10-digit number")
    .required("Contact number is a required field"),
  state: Yup.string().required("State is a required field"),
  city: Yup.string().required("City is a required field"),
  treatmentDetails: Yup.string().required("Treatment/Investigations Recommended is a required field"),
  yourMessage: Yup.string().required("Message is a required field"),
});

const CustomContactForm = () => {
  const submit = useSubmit();
  const navigation = useNavigation();

  const initialValues = {
    selectedReason: "",
    assistanceRequired: "",
    name: "",
    email: "",
    contact: "",
    country: "India",
    state: "Maharashtra",
    city: "Mumbai",
    zip_code: "",
    treatmentDetails: "",
    yourMessage: "",
  };

  const handleSubmit = (values) => {
    values.title = "Register for Contact Us";
    submit(values, { method: "POST" });
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
      <Form className="mb15">
        <div className="row">
          <div className="col-md-12">
            <div className="mb15">
              Fields marked with an <span className="requiredColor">*</span> are required
            </div>
            <CommonInputs disabledFields={['state', 'city']} hiddenFields={['country', 'zip_code', 'locality']} />
            <div className="form-group">
              <label className="required">Assistance Required from Madat Trust</label>
              <Field as="select" name="assistanceRequired" className="form-control">
                <option value="">Select Assistance Type</option>
                <option value="Discounted Medical Service">Discounted Medical Service</option>
                <option value="Financial aid">Financial aid</option>
              </Field>
              <ErrorMessage name="assistanceRequired" component="div" className="text-danger" />
            </div>
            <div className="form-group">
              <label className="required">Medical Services Required</label>
              <Field as="select" name="selectedReason" className="form-control">
                <option value="">Select Medical Service</option>
                <option value="Breast Cancer Surgery in Mumbai">Breast Cancer Surgery in Mumbai</option>
                <option value="Head Neck Cancer Surgery in Mumbai">Head Neck Cancer Surgery in Mumbai</option>
                <option value="Chemotherapy in Mumbai">Chemotherapy in Mumbai</option>
                <option value="Radiation Treatment in Mumbai">Radiation Treatment in Mumbai</option>
                <option value="CT Scan">CT Scan</option>
                <option value="Nuclear Scans">Nuclear Scans</option>
                <option value="Pathology Services">Pathology Services</option>
                <option value="Mammography - Karo janch na aayegi aanch program">Mammography - Karo janch na aayegi aanch program</option>
                <option value="Pet CT">Pet CT</option>
                <option value="MRI Scan">MRI Scan</option>
              </Field>
              <ErrorMessage name="selectedReason" component="div" className="text-danger" />
            </div>
            <div className="form-group">
              <label className="required">Treatment/Investigations Recommended</label>
              <Field type="text" name="treatmentDetails" className="form-control" />
              <ErrorMessage name="treatmentDetails" component="div" className="text-danger" />
            </div>
            <div className="form-group">
              <label className="required" htmlFor="yourMessage">Your Message</label>
              <Field className="form-control" as="textarea" id="yourMessage" name="yourMessage" placeholder="Your Message" />
              <ErrorMessage name="yourMessage" component="div" className="text-danger" />
            </div>
            <button className="btn btn-primary my-2 my-sm-0 Allbtn" type="submit">
              {navigation.state === "submitting" ? "Processing..." : navigation.state === "loading" ? "Saved!" : "Submit"}
            </button>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default CustomContactForm;
